import {
  ConditionReserve,
  ConditionReserveFromJSON,
  ConditionReserveLimit,
  defaultConditionReserveLimit,
  ConditionReserveExtendGroup,
  exists,
  ConditionReserveLimitFromJSON,
  ConditionReserveExtendGroupFromJSON
} from '@/api'

export interface ReserveCondition {
  reserves: ConditionReserve[]
  reserveLimit: ConditionReserveLimit
  reserveExtendGroups: ConditionReserveExtendGroup[]
}

export const defaultReserveCondition = (): ReserveCondition => ({
  reserves: [],
  reserveLimit: defaultConditionReserveLimit(),
  reserveExtendGroups: []
})

export function ReserveConditionFromJSON(json: any): ReserveCondition {
  return {
    reserves: exists(json, 'reserves')
      ? json.reserves.map(ConditionReserveFromJSON)
      : [],
    reserveLimit: exists(json, 'reserve_limit')
      ? ConditionReserveLimitFromJSON(json.reserve_limit)
      : defaultConditionReserveLimit(),
    reserveExtendGroups: exists(json, 'reserve_extend_groups')
      ? json.reserve_extend_groups.map(ConditionReserveExtendGroupFromJSON)
      : []
  }
}
